import image1 from "../../public/AIC2024.png";
import image2 from "../../public/Bosch2024.png";
import image3 from "../../public/UIT2022.png";
import React from "react";

export const AwardItemDesktop = ({
  time,
  title,
  description,
  isLastItem,
  hoverId,
  hoveredIndex,
  setHoveredIndex,
}: any) => {
  const images = [image1, image2, image3];
  const currentImage = images[hoverId-1];

  const [mousePosition, setMousePosition] = React.useState({ x: 0, y: 0 });

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    setMousePosition({ x: e.clientX, y: e.clientY });
  };

  return (
    <div
      className={`relative flex flex-row ${!isLastItem ? "pb-6 " : ""} ${
        hoveredIndex == undefined || hoveredIndex == hoverId ? "" : ""
      }`}
      onMouseEnter={() => setHoveredIndex(hoverId)}
      onMouseLeave={() => setHoveredIndex(undefined)}
      onMouseMove={handleMouseMove}
    >
      <div className="w-[80px]">{time}</div>
      <div className="flex flex-col ml-[90px]">
        <p className="font-medium mb-1">{title}</p>
        <p className="text-gray-4 w-[720px]">{description}</p>
      </div>
      {hoveredIndex === hoverId && (
        <div
          className="fixed z-10 pointer-events-none"
          style={{
            top: mousePosition.y - 140,
            left: mousePosition.x - 75,
          }}
        >
          <img
            src={currentImage}
            alt="Hover image"
            className="w-[150px] object-contain"
          />
        </div>
      )}
    </div>
  );
};
